import Button from 'components/button';
import { useDispatch, useSelector } from 'store/hooks';

import ResultBox from 'components/result-box';
import { useOCR } from 'layouts/application';
import scoringStyles from '../scoring/scoring.module.scss';
import styles from './ocr.module.scss';
import useFileState from './hook-file';
import Section from './section-file-upload';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const OCR = () => {
	const contextApplication = useSelector((state) => state.application);
	const { handleRunOCR, ocrPending } = useOCR();
	const { fileOcr, fileGuarantors, formValid, handleFileChangeOcr, handleFileChangeGuarantor } =
		useFileState(contextApplication.data?.number_of_guarantors!);

	const handleRun = () => {
		if (!formValid) return;
		handleRunOCR(fileOcr, fileGuarantors);
	};

	return (
		<div className={styles.ocr}>
			<div className={scoringStyles.section}>
				<Section
					pending={ocrPending}
					log={contextApplication.data?.ocr_log}
					application={contextApplication.data}
					file={fileOcr}
					fileGuarantors={fileGuarantors}
					handleFileChange={handleFileChangeOcr}
					handleFileChangeGuarantor={handleFileChangeGuarantor}
				/>
				{formValid && !ocrPending && !contextApplication.data?.ocr_log && (
					<div className={styles.footerBox}>
						<div className={styles.buttonGroup}>
							<Button blocked={ocrPending} onClick={handleRun}>
								Run OCR
							</Button>
						</div>
					</div>
				)}
			</div>
			<div className={styles.result}>
				<ResultBox />
			</div>
		</div>
	);
};

export default OCR;
